import React, {useState} from "react";
import { Box, Grid, GridItem, Center, Text, Input, Button, Select, Checkbox } from '@chakra-ui/react';
import Autosuggest from "react-autosuggest";
import '../Stylesheets/autosuggestInputTheme.css';
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet-async";
import { HmacMD5 } from "crypto-js";

// Default Base URL
const baseUrl = window.location.origin === "https://forms.maitland.nsw.gov.au" ? 
    process.env.REACT_APP_APIURL : process.env.REACT_APP_NONPRODAPIURL;

export default function PropertyCertificates() {

    // Set small screen size
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 700px)"
    });

    // Set Count Variable
    var count = 0;

    const allPriceData = [];
    // Set state variables
    const [certificateCost , setCertificateCost] = useState(0);
    const [certificateTypeDisplay , setCertificateTypeDisplay] = useState(null);
    const [accessToken , setAccessToken] = useState(null);
    const [sharedToken, setSharedToken] = useState(null);
    const [esriToken, setEsriToken] = useState(null);
    const [emailAddress , setEmailAddress] = useState(null);
    const [tokenExecuted, setTokenExecuted] = useState(false);
    const [esriTokenExecuted, setEsriTokenExecuted] = useState(false);
    const [priceDataExecuted, setPriceDataExecuted] = useState(false);
    const [submittedDetails, setSubmittedDetails] = useState(false);
    const [is107Form, setIs107Form] = useState(false);
    const [isBlockRegistered, setIsBlockRegistered] = useState('yes');    
    const [reference, setReference] = useState(null);
    const [pleaseWait, setPleaseWait] = useState(false);
    const [priceData, setPriceData] = useState(allPriceData);

    if (!tokenExecuted) {
        retreiveAccessToken();

        var thisReference = "INV-PC" + new Date().getTime();
        setReference(thisReference);
    }

    if (!esriTokenExecuted) {
        retreiveEsriToken();
    }

    if (!priceDataExecuted) {
        retreivePricingData();
    }

    // Called when clicking submit and pay button
    function handleValidation() {
        // Make sure count starts off as 0
        count = 0;
        // Get Required Fields
        var applicantName = document.getElementById("applicantName");
        var phoneNumber = document.getElementById("phoneNumber");
        var emailAddress = document.getElementById("emailAddress");
        var lotNumber = document.getElementById("lotNumber");
        var dpNumber = document.getElementById("dpNumber");
        var propertyAddress = document.getElementById("propertyAddress");
        var suburb = document.getElementById("suburb");
        var postCode = document.getElementById("postCode");     
        var termsAccepted = document.getElementById("acceptTerms");
        // Get all other fields
        var postalAddress = document.getElementById("postalAddress");
        var companyName = document.getElementById("companyName");
        var clientReference = document.getElementById("clientReference");
        var ownersName = document.getElementById("ownersName");        
        var section = document.getElementById("section");
        
        // Add all required fields into an array
        var requiredFields = [applicantName, phoneNumber, emailAddress, lotNumber,
            dpNumber, propertyAddress, suburb, postCode];
            
        // Loop through the array and validate each item
        requiredFields.forEach(function(thisField){
            checkInputHasValue(thisField);
        });

        ValidateEmail(emailAddress);

        if (!termsAccepted.checked) {
            document.getElementById("acceptLabel").style.color = "red";
        } else {
            document.getElementById("acceptLabel").style.color = "black";
        }

        if (count === 0 && termsAccepted.checked) {            

            
            if (accessToken != null) {

                var selectedCertificateType = document.getElementById("certificateType");

                var propertyCertificateModel = JSON.stringify({
                    "propertyCertificateType": selectedCertificateType.value,
                    "applicantName": applicantName.value,
                    "phoneNumber": phoneNumber.value,
                    "emailAddress": emailAddress.value,
                    "lotNumber": lotNumber.value,
                    "section": section.value,
                    "planNumber": dpNumber.value,
                    "propertyAddress": propertyAddress.value,
                    "suburb": suburb.value,
                    "postCode": postCode.value,
                    "postalAddress": postalAddress.value,
                    "companyName": companyName.value,
                    "clientReference": clientReference.value,
                    "propertyOwner": ownersName.value,
                    "accessToken": accessToken,
                    "amount": certificateCost,
                    "invoiceNumber": reference
                });
                
                setEmailAddress(emailAddress.value);                
                
                var amount = certificateCost * 100;

                propertyCertificatePost(propertyCertificateModel, amount); 
            }
        }
    }

    function navigateToFatZebra(amount) {
        // Navigate to FatZebra Payment
        var sharedSecret = sharedToken; 
        var fzUsername = "TESTmaitland";
        var paymentUrl = "https://paynow.pmnts-sandbox.io/v2";                
        var returnPath = "https://mcc-ae-nonprod-forms.azurewebsites.net/propertycertificatespaid";
        if (window.location.origin === "https://forms.maitland.nsw.gov.au") {
            fzUsername = "maitlandpropertycert";
            paymentUrl = "https://paynow.pmnts.io/v2";
            returnPath = "https://forms.maitland.nsw.gov.au/propertycertificatespaid";
        }

        var encrypted = HmacMD5([reference, amount, 'AUD', returnPath].join(':'),sharedSecret).toString();

        setSubmittedDetails(true);    
        window.top.location.href = `${paymentUrl}/${fzUsername}/${reference}/AUD/${amount}/${encrypted}?return_path=${returnPath}&amp;cards=&amp;show_email=false&amp;enable_sca=false&amp;hide_button=false&amp;tokenize_only=false&amp;hide_logos=true`;              
    }

    
    function retreiveAccessToken() {        
        // Retreive Access Token for payment.
        fetch(baseUrl + "property/fz-access-token", {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {
            setAccessToken(response.access_token);
            setSharedToken(response.shared_secret);
        })
        .catch(error => console.log(error));

        setTokenExecuted(true);
    }

    function retreiveEsriToken() {        
        // Retreive Esri Token for autoSuggest.
        fetch(baseUrl + "property/esri-token", {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {
            setEsriToken(response.message);
        })
        .catch(error => console.log(error));

        setEsriTokenExecuted(true);
    }

    function retreivePricingData() {        
        // Retreive Esri Token for autoSuggest.
        fetch(baseUrl + "property/pricing", {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {
            response.forEach((item, index) => {
                priceData.push({
                    propertyCertificateType: item.propertyCertificateType,
                    propertyCertificateDisplayName: item.propertyCertificateDisplayName,
                    propertyCertificateFee: item.propertyCertificateFee
                });
            });
            setPriceData(priceData);
        })
        .catch(error => console.log(error));

        setPriceDataExecuted(true);
    }

    // Validation
    function checkInputHasValue(property) {
        if (property.value.length === 0) {
            flagRequired(property);
            count++;
        } else {
            removeFlagRequired(property);
        }
    }

    function flagRequired(property) {
        property.style.borderColor = "red";
    } 

    function removeFlagRequired(property) {
        property.style.borderColor = "lightgray";
    }

    // Api call
    function propertyCertificatePost(propertyCertificateModel, amount) {
        // Store details on property certificate

        //Set please wait for slow browsers
        setPleaseWait(true);

        fetch(baseUrl + "property/certificates", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: propertyCertificateModel
        })
        .then(response => response.json())
        .then(response => {           
            console.log(response); 
            if(response.statusCode === 200) {
                navigateToFatZebra(amount);
            }
        })
        .catch(error => {
            // Undo please wait if error
            setPleaseWait(false);
            console.log(error);
        });
    }

    // Api call
    function deletePropertyCertificatePost() {
        // Store details on property certificate
        var parameters = "?emailAddress=" + emailAddress + "&accessToken=" + accessToken;

        fetch(baseUrl + "property/certificates" + parameters, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(response => {           
            console.log(response); 
            setPleaseWait(false);
        })
        .catch(error => console.log(error));
        return true;
    }

    function handleCancelAndReturn() {
        // Return to page > Delete cancel from database if not paid > reload page
        setSubmittedDetails(false);
        deletePropertyCertificatePost();
        window.location.reload();
    }
    
    // Changes the cost value of the property certificate form
    function setCertificatePrice() {
        var selectedCertificateType = document.getElementById("certificateType");
        
        // Create values and set price and display name
        var objectNumber = null;
        priceData.forEach((item, index) => {
            if (item.propertyCertificateType === selectedCertificateType.value) {
                objectNumber = index;
            }
        });
        if (objectNumber != null) {
        var thisPriceData = priceData[objectNumber];
            setCertificateCost(thisPriceData.propertyCertificateFee);
            setCertificateTypeDisplay(thisPriceData.propertyCertificateDisplayName);
        } else {
            setCertificateCost(0);
            setCertificateTypeDisplay(null);
        }

        if (selectedCertificateType.value.includes("10.7")) {
            setIs107Form(true);
        } else {
            setIs107Form(false);
            setIsBlockRegistered('yes');
        }
    }

    // Validate that the value entered looks like an email address.
    function ValidateEmail(input) {
        // Validation Regular Expression
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;      
        if (!input.value.match(validRegex)) {  
            // If invalid flag that it's required and add to error count      
            flagRequired(input);
            count++;
        } 
    }

    // Auto Suggest typing time out for input to reduce api calls done
    const [postalTimer, setPostalTimer] = useState(null);
    const [propertyTimer, setPropertyTimer] = useState(null);

    // Input change for postal address
    const postalInputChanged = e => {

        clearTimeout(postalTimer);

        const newTimer = setTimeout(() => {
            AutoSuggestFunction();
        }, 500);

        setPostalTimer(newTimer);
    }

    // Use AutoSuggest api from ARCGIS -- Postal Address
    function AutoSuggestFunction() {
        setTimeout(function(){
            var postalAddress = document.getElementById('postalAddress');
            if(postalAddress.value.length > 4) {
                var url = 'https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?f=json&text=' + postalAddress.value + '&token=' + esriToken + '&category=Address&countryCode=AUS';
                fetch(url, {method:  "POST"})
                .then(response => response.json())
                .then(response => {           
                    setPostalSuggestions(response.suggestions.map(row => ({
                        address: row.text
                    })));
                })
                .catch(error => console.log(error));
            }
        }, 200);
    }

    // Input change for property
    const propertyInputChanged = e => {

        clearTimeout(propertyTimer);

        const newTimer = setTimeout(() => {
            AutoSuggestFunctionMaitlandOnly();
        }, 500);

        setPropertyTimer(newTimer);
    }

    // Use AutoSuggest api from Wastetrack layer of ARCGIS, displayed only Maitland LGA Address
    function AutoSuggestFunctionMaitlandOnly() {
        setTimeout(function(){
            var propertyAddress = document.getElementById('propertyAddress');
            if(propertyAddress.value.length > 4) {
                fetch(baseUrl + "wastetrack/search-bin?addressText=" + propertyAddress.value, {
                    method: "GET"
                })
                .then(response => response.json())
                .then(response => {           
                    const theseSuggestions = [];
                    var count = 0;
                    response.forEach(function(thisSuggestion) {
                        theseSuggestions[count] = thisSuggestion;
                        count++;
                    })

                    setPropertySuggestions(theseSuggestions.map(row => ({
                        address: (row.unit_number ? `${row.unit_number}/` : "") + row.street_number + " " + row.street_name + ", " + row.suburb + ", " + row.postcode
                    })));
                })
                .catch(error => console.log(error));
            }
        }, 200);
    }

    // Set variables from autosuggest on Property Address to autocomplete PropertyAddress, Suburb and PostCode
    function SetPropertyAddressDetails(value) {
        // Trim Value and Set details
        var arrayValues = value.split(',');

        //Set Suburb and PostCode
        var suburb = document.getElementById('suburb');
        var postCode = document.getElementById('postCode');
        suburb.value = arrayValues[1].trim();
        postCode.value = arrayValues[2].trim();

        // Return this value 
        return arrayValues[0];
    }
    
    // Set states for AutoSuggest input fields
    const [postalAddress, setPostalAddress] = useState("");
    const [propertyAddress, setPropertyAddress] = useState("");
    const [postalSuggestions, setPostalSuggestions] = useState([]);
    const [propertySuggestions, setPropertySuggestions] = useState([]);

    return (
        <>
            <Helmet>
                <meta http-equiv="Content-Security-Policy" content={`default-src 'self'; style-src 'self' https://maitlandapi.wpengine.com/mccds/ 'unsafe-inline'; 
                    connect-src 'self' ${baseUrl}property/ ${baseUrl}wastetrack/ 
                    https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest`} />
            </Helmet>
            {!submittedDetails &&
            <Box marginTop='2%' marginLeft='5%' maxW='90%'>
                <Grid templateColumns='repeat(1, 1fr)' gap={3}>
                    <GridItem w='100%'>
                        <Text fontSize='2xl' fontWeight="bold">Application Form</Text>
                    </GridItem>
                    <GridItem w='100%'>
                        <Text fontSize='xl' fontWeight="bold">Certificate Type</Text>
                        <Box marginTop='2%' border="1px gray solid" borderRadius="5px">
                            <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'} gap={3}>
                                <GridItem margin="10%" w='80%'>
                                    <Select id="certificateType" onChange={setCertificatePrice} focusBorderColor="green.500" height="40px" fontSize="lg" placeholder="-- Please Select --">
                                        <option value='standard603'>Section 603 Certificate - Standard</option>
                                        <option value='express603'>Section 603 Certificate - Express</option>
                                        <option value='standard10.7'>Section 10.7 Planning Certificate - Standard</option>
                                        <option value='express10.7'>Section 10.7 Planning Certificate - Express</option>
                                        <option value='standard10.7and5'>Section 10.7 and (5) Planning Certificate - Standard</option>
                                        <option value='express10.7and5'>Section 10.7 and (5) Planning Certificate - Express</option>
                                        <option value='standard121zp'>Section 121ZP</option>
                                        <option value='standard735a'>Section 735A</option>
                                    </Select>
                                </GridItem>
                                <GridItem w='100%'>
                                    <Center>
                                        <Text marginTop="6%" fontSize="xl" fontWeight="bold">Price: ${certificateCost}</Text>
                                    </Center>
                                    <Center>
                                        <Text fontSize="lg">{certificateTypeDisplay}</Text>
                                    </Center>
                                    <Center>
                                        <Text fontSize="lg">One Off Payment</Text>
                                    </Center>
                                </GridItem>
                            </Grid>
                        </Box>
                    </GridItem>  
                {certificateTypeDisplay && <>               
                    {is107Form && <>
                        <GridItem w='100%'>
                            <Text fontSize="xl" fontWeight="bold">Is your block registered?</Text>&nbsp;
                            <Select w="120px" onChange={(e) => setIsBlockRegistered(e.target.value)}>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </Select>
                        </GridItem>
                        {isBlockRegistered === 'no' && <>
                            <GridItem w='100%'>
                                <Center>
                                    <Text fontSize="xl" fontWeight="bold" className="notice-warning">
                                        WARNING: It is recommened you wait until the block is registered. We will <span style={{textDecoration: "underline"}}>NOT</span> process this form until the block is registered.
                                    </Text>
                                </Center>
                            </GridItem>
                        </> }
                    </>}
                    <GridItem w='100%'>
                        <Text fontSize='xl' fontWeight="bold">Customer Details</Text><br />
                        <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'} gap={3}>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Applicant Name<span className="requiredField">Required</span></Text>
                                <Input id="applicantName" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                            </GridItem>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Phone Number<span className="requiredField">Required</span></Text>
                                <Input id="phoneNumber" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" type='number' onWheel={(e) => e.target.blur()} />
                            </GridItem>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Email Address<span className="requiredField">Required</span></Text>
                                <Input id="emailAddress" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                            </GridItem>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Postal Address</Text>
                                <Autosuggest 
                                    inputProps={{
                                        autoComplete: "abcd",
                                        name: "postalAddress",
                                        id: "postalAddress",
                                        value: postalAddress,
                                        onChange: (_event, { newValue }) => {
                                            setPostalAddress(newValue);
                                        }
                                    }}
                                    suggestions={postalSuggestions}
                                    onSuggestionsFetchRequested={async ({ value }) => {
                                        if (!value) {
                                            setPostalSuggestions([]);
                                            return;
                                        }
                                        try {
                                            postalInputChanged();
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    }}
                                    onSuggestionsClearRequested={() => {
                                        setPostalSuggestions([]);
                                    }}
                                    getSuggestionValue={suggestion => suggestion.address}
                                    renderSuggestion={suggestion => <div className="binSuggestion">
                                        {suggestion.address}
                                    </div>}
                                />
                            </GridItem>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Company Name</Text>
                                <Input id="companyName" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                            </GridItem>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Client Reference</Text>
                                <Input id="clientReference" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                            </GridItem>
                        </Grid>
                    </GridItem>
                    <GridItem w='100%'>
                        <Text fontSize='xl' fontWeight="bold">Property Details</Text><br />
                        <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)'} gap={3}>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Lot number<span className="requiredField">Required</span></Text>
                                <Input id="lotNumber" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                            </GridItem>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Section</Text>
                                <Input id="section" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" placeholder='NA - if not applicable' />
                            </GridItem>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">DP/SP NO.<span className="requiredField">Required</span></Text>
                                <Input id="dpNumber" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                            </GridItem>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Property Address<span className="requiredField">Required</span></Text>
                                <Autosuggest 
                                    inputProps={{
                                        autoComplete: "abcd",
                                        name: "propertyAddress",
                                        id: "propertyAddress",
                                        value: propertyAddress,
                                        onChange: (_event, { newValue }) => {
                                            setPropertyAddress(newValue);
                                        }
                                    }}
                                    suggestions={propertySuggestions}
                                    onSuggestionsFetchRequested={async ({ value }) => {
                                        if (!value) {
                                            setPropertySuggestions([]);
                                            return;
                                        }
                                        try {
                                            propertyInputChanged();
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    }}
                                    onSuggestionsClearRequested={() => {
                                        setPropertySuggestions([]);
                                    }}
                                    getSuggestionValue={suggestion => SetPropertyAddressDetails(suggestion.address)}
                                    renderSuggestion={suggestion => <div className="binSuggestion">
                                        {suggestion.address}
                                    </div>}
                                />
                            </GridItem>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Suburb<span className="requiredField">Required</span></Text>
                                <Input id="suburb" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                            </GridItem>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Postcode<span className="requiredField">Required</span></Text>
                                <Input id="postCode" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" type='number' onWheel={(e) => e.target.blur()} />
                            </GridItem>
                        </Grid> <br />
                        <Grid templateColumns='repeat(1, 1fr)' gap={3}>
                            <GridItem w='100%'>
                                <Text fontSize="md" fontWeight="bold">Property Owners name</Text>
                                <Input id="ownersName" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" />
                            </GridItem>
                        </Grid>
                    </GridItem>
                    <GridItem w='100%'>
                        <Text fontSize='xl' fontWeight="bold">Payment</Text><br />
                    </GridItem>
                    <GridItem w="100%">
                        <Checkbox id="acceptTerms" size="lg" colorScheme="green"><span id="acceptLabel">Accept</span> 
                        <Text fontSize="sm" textTransform="capitalize">
                            <span style={{fontWeight: "bold"}}>Properties Outside Maitland </span>
                            - Please check that the property certificate you are applying for is 
                            <span style={{fontWeight: "bold"}}> within our Council area. </span> 
                            No refunds will be provided for certificates lodged in error, or change of mind.
                        </Text>
                        </Checkbox>
                    </GridItem>
                    <GridItem w='100%'>
                        <Button w="100%" variant="Primary" padding="25px" onClick={() => handleValidation()} isDisabled={pleaseWait}>{pleaseWait ? `Please Wait` : "Submit and Pay"}</Button>
                    </GridItem>
                </>}
                </Grid>
            </Box>
            }
            {submittedDetails &&
                <>
                    <Center>
                        <Button onClick={() => handleCancelAndReturn()} size="lg" variant="Primary">&lt; Back</Button>
                    </Center>
                </>
            }
        </>
    );
}